export default "__VITE_ASSET__BEKI2NLJ__"